export default __webpack_public_path__ + "static/media/BR.acf8bd84.svg";